import { Modal as AntdModal } from 'antd'

export const Modal = (props: any) => <AntdModal {...props} />
